// extracted by mini-css-extract-plugin
module.exports = {"main":"flavours-xdl-main-5f7767b0","other":"flavours-xdl-other-bee49475"};